import { IconSvg, PrismIconName } from '@sd/prism';

export type PrismIconVariant = `${PrismIconName}`;
export type IconVariant = PrismIconVariant;
type Props = {
  variant: IconVariant;
  className?: string;
  id?: string;
  color?: string;
  title?: string;
  height?: string;
  onClick?: () => void;
};

/**
 * Prism https://prism.coxautoinc.com/docs/components/icons
 */
export const Icon = ({ variant, ...iconProps }: Props) => {
  return <IconSvg {...iconProps} glyph={`${variant}`} className={`${iconProps.className ?? ''}`} />;
};
